import React from "react";
import { Title, TitleProps, useMantineTheme } from "@mantine/core";

interface Heading2Props extends Omit<TitleProps, "order" | "styles"> {
  children: React.ReactNode;
  variant?: "default" | "shadow";
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Heading2 - Styled H2 component
 * Usage: <Heading2>Section Title</Heading2>
 * Usage with shadow: <Heading2 variant="shadow">Section Title</Heading2>
 */
export const Heading2: React.FC<Heading2Props> = ({
  children,
  variant = "default",
  className,
  style,
  ...props
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  const getTextShadow = () => {
    if (variant === "shadow") {
      return "0 2px 6px rgba(0, 0, 0, 0.4), 0 2px 12px rgba(0, 0, 0, 0.2)";
    }
    return undefined;
  };

  return (
    <Title
      order={2}
      className={className}
      style={{
        color: other.textPrimary,
        fontWeight: 700,
        textShadow: getTextShadow(),
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
};

export default Heading2;
